import {
    SHARE
} from "../../constants/ActionTypes";

const INIT_STATE = {
    shareData: {}
};

export default (state = INIT_STATE, action) => {
    
    switch (action.type) {
        case SHARE: {
            return {
                ...state,
                shareData: action.payload,
            }
        }

        default:
            return state;
    }
}